import React from 'react';
import { UtilsBlock, Icon, Title4 } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import Classes from './SellSteps.module.scss';

const STEPS = [
  { key: 'step1', icon: 'search' },
  { key: 'step2', icon: 'camera' },
  { key: 'step3', icon: 'messages' },
] as const;

const SellSteps = () => {
  const { t } = useI18nContext();

  return (
    <div className={Classes.root}>
      <UtilsBlock mb={['m', 'xl', null]}>
        <Title4 as="h2" utilities={['marginBottomXxs']} className="Section-title">
          <span>{t('sell.page.steps.title')}</span>
          <span className="Title-highlight">{t('sell.page.steps.titleHighlight')}</span>
        </Title4>
      </UtilsBlock>
      <ol className={Classes.steps}>
        {STEPS.map(({ key, icon }, index) => (
          <li key={key} className={Classes.step}>
            <div className={Classes.iconCircle}>
              <Icon name={icon} color="text-brand-primary" />
            </div>
            <div className={Classes.stepContent}>
              <UtilsBlock
                textStyle={['body-small-strong', null, 'title-5']}
                className={Classes.stepTitle}
              >{`${index + 1}. ${t(`sell.page.steps.${key}.title`)}`}</UtilsBlock>
              <UtilsBlock color="text-secondary">{t(`sell.page.steps.${key}.body`)}</UtilsBlock>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default SellSteps;
